export const ROUTE_PATHS = {
  _: '',
  home: '/',
  consultation: 'consultation',
  consultation_guid: ':id',
} as const;
